import React from 'react'

import Image from '../../resources/20943953.png'
import ContactForm from '../../components/en/ContactForm'
import Header from '../../components/en/Header'

export default function ContactPage() {
  return (
    <div>
      <Header/>
      <div className='grid bg-[var(--colorSecondary)]'>
        <div className='grid mx-auto my-10 bg-white pt-5 pb-20
            lg:px-20'>
          <div className='max-w-[750px]'>
            <img src={Image} alt='Contact Us img'></img>
          </div>
          <div className=''>
            <div className=''>
              <TopService/>
            </div>
            <div className=''>
              <ContactForm/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


const TopService = () => {
  return(
      <div className=''>
          <div className='grid mx-10
              md:container md:mx-auto'>
              <h3 className='uppercase text-xl font-bold mb-2
                  text-[var(--colorPrimary)]'>OUR TOP SERVICES</h3>
              <ul className='my-5'>
                <li>✔ <span className='font-medium'>24h</span> response time</li>
                <li>✔ <span className='text-green-600 font-medium'>Free</span> online quotation</li>
                <li>✔ <span className='font-medium'>Transparency</span> </li>
              </ul>
          </div>
      </div>
  )
}